import Vue from 'vue';
import formatPrice from '../helpers/formatPrice';

Vue.filter('formatPrice', function (value) {
  return formatPrice(value);
});
